import { render, staticRenderFns } from "./optional-products.vue?vue&type=template&id=7b2c8690&"
import script from "./optional-products.vue?vue&type=script&lang=js&"
export * from "./optional-products.vue?vue&type=script&lang=js&"
import style0 from "./optional-products.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports